import { useState } from 'react';
import { AxiosError } from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { isAuth, useAsyncEffect, useForm, validators } from '@recargas-dominicanas/core/utils';
import { BusinessUserApi } from '@recargas-dominicanas/core/api';
import { style } from './login.module.css';

import { 
  Icon, 
  OutlineButton,
  TextField, 
  Title, 
  Error, 
  Brand 
} from '@recargas-dominicanas/core/components';

export function Login() {

  const navigate = useNavigate();
  const form = useForm({ userName: '', password: '' });
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [showPassword, setShowPassword] = useState(false);

  useAsyncEffect(async () => {

    const auth = await isAuth('businessUser');

    if (auth) {
      navigate('/');
    } else {
      setLoading(false);
    }
  });

  async function handleLogin() {

    setErrorMessage(undefined);

    if (!form.isValid()) return;

    try {

      const { userName, password } = form.value;
      await BusinessUserApi.login(userName, password);
      
      navigate('/');

    } catch (err) {

      if (err instanceof AxiosError && err.response?.status === 401) {
        setErrorMessage('Nombre de usuario o contraseña incorrecta');
      } else {
        setErrorMessage('Ocurrio un error al tratar de iniciar sesión');
      }
    }
  }

  if (loading) {
    return null;
  }

  return (
    <div className={style.container}>
      <Brand style={style.brand}/>
      <div className={style.card}>
        <Icon className={style.cardIcon} icon='account_circle'/>
        <Title style={style.cardTitle} title='Iniciar sesión'/>
        <form className={style.form}>
          <TextField
            style={style.emailField} 
            label='Nombre de usuario'
            formField={form.fields.userName}
            validators={[validators.required]}/>
          <TextField
            style={style.passwordField}
            type={showPassword ? 'text' : 'password'}
            label='Contraseña'
            formField={form.fields.password}
            onEnter={handleLogin}
            rightIcon={
              <Icon 
                icon={showPassword ? 'visibility' : 'visibility_off'} 
                onClick={() => setShowPassword(show => !show)}/>
            }
            validators={[
              validators.required,
              validators.length(5, 'La contraseña debe tener al menos 5 caracteres')
            ]}/>
        </form>
        <Error 
          show={errorMessage !== undefined}
          message={errorMessage!}/>
        <OutlineButton
          style={style.button}
          text='Iniciar sesión'
          onClick={handleLogin}/>
        <div className={style.signupContainer}>
          <span className={style.signupLabel}>¿No tienes una cuenta?</span>
          <Link to='/crear-cuenta' className={style.signupLink}>Regístrate aquí</Link>
        </div>
      </div>
    </div>
  );
}
